import * as React from 'react';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import './ClientFooterContent.css';

const ClientFooterContent: React.FunctionComponent = () => {
  return (
    <Row className="ClientFooterContent">
      <Col xs="12">
        <Nav className="float-right">
          <NavItem>
            <NavLink target="_blank" className="cookiePolicyLink" href="https://www.lloydsbank.com/cookies.asp">
              Cookie policy
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink target="_blank" className="commercialBankingLink"
                     href="https://commercialbanking.lloydsbank.com/home/">Commercial Banking</NavLink>
          </NavItem>
          <NavItem>
            <NavLink target="_blank" className="securityLink"
                     href="https://resources.lloydsbank.com/cbonlinesupport/security/">Security</NavLink>
          </NavItem>
          <NavItem>
            <NavLink target="_blank" className="legalLink"
                     href="https://commercialbanking.lloydsbank.com/legal/">Legal</NavLink>
          </NavItem>
          <NavItem>
            <NavLink target="_blank" className="privacyLink"
                     href="https://commercialbanking.lloydsbank.com/privacy/">Privacy</NavLink>
          </NavItem>
        </Nav>
      </Col>
    </Row>
  );
};


export default ClientFooterContent;



// WEBPACK FOOTER //
// ./src/components/shared/footer/client/ClientFooterContent.tsx